export enum ApplicationTableColumns {
  productName = "productName",
  vendorName = "vendorName",
  productDomain = "productDomain",
  vendorDomain = "vendorDomain",
  category = "category",
  mspVitalityScore = "mspVitalityScore",
  isForConsumers = "isForConsumers",
  isSaas = "isSaas",
  isVisible = "isVisible",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  productDescription = "productDescription",
  vendorDescription = "vendorDescription",
}

export const APPLICATION_TABLE_COLUMN_LABELS: Record<
  ApplicationTableColumns,
  string
> = {
  [ApplicationTableColumns.productName]: "Product Name",
  [ApplicationTableColumns.vendorName]: "Vendor Name",
  [ApplicationTableColumns.productDomain]: "Product Domain",
  [ApplicationTableColumns.vendorDomain]: "Vendor Domain",
  [ApplicationTableColumns.category]: "Category",
  [ApplicationTableColumns.mspVitalityScore]: "MSP Vitality Score",
  [ApplicationTableColumns.isForConsumers]: "For Consumers",
  [ApplicationTableColumns.isSaas]: "Is SaaS?",
  [ApplicationTableColumns.isVisible]: "Is Visible?",
  [ApplicationTableColumns.createdAt]: "Created At",
  [ApplicationTableColumns.updatedAt]: "Updated At",
  [ApplicationTableColumns.productDescription]: "Product Description",
  [ApplicationTableColumns.vendorDescription]: "Vendor Description",
};

export const DEFAULT_APPLICATION_TABLE_COLUMN_ORDER: ApplicationTableColumns[] =
  [
    ApplicationTableColumns.productName,
    ApplicationTableColumns.vendorName,
    ApplicationTableColumns.productDomain,
    ApplicationTableColumns.category,
    ApplicationTableColumns.mspVitalityScore,
    ApplicationTableColumns.isForConsumers,
    ApplicationTableColumns.createdAt,
    ApplicationTableColumns.updatedAt,
  ];

export const DEFAULT_APPLICATION_TABLE_COLUMN_SETTINGS: Record<
  ApplicationTableColumns,
  boolean
> = {
  [ApplicationTableColumns.productName]: true,
  [ApplicationTableColumns.vendorName]: true,
  [ApplicationTableColumns.productDomain]: false,
  [ApplicationTableColumns.vendorDomain]: false,
  [ApplicationTableColumns.category]: true,
  [ApplicationTableColumns.mspVitalityScore]: false,
  [ApplicationTableColumns.isForConsumers]: false,
  [ApplicationTableColumns.isSaas]: false,
  [ApplicationTableColumns.isVisible]: false,
  [ApplicationTableColumns.createdAt]: false,
  [ApplicationTableColumns.updatedAt]: false,
  [ApplicationTableColumns.productDescription]: false,
  [ApplicationTableColumns.vendorDescription]: false,
};

export const ADMIN_APPLICATION_TABLE_COLUMN_SETTINGS: Record<
  ApplicationTableColumns,
  boolean
> = {
  ...DEFAULT_APPLICATION_TABLE_COLUMN_SETTINGS,
  [ApplicationTableColumns.isSaas]: true,
  [ApplicationTableColumns.isVisible]: true,
};

export const ADMIN_APPLICATION_TABLE_COLUMN_ORDER: ApplicationTableColumns[] = [
  ApplicationTableColumns.productName,
  ApplicationTableColumns.vendorName,
  ApplicationTableColumns.category,
  ApplicationTableColumns.mspVitalityScore,
  ApplicationTableColumns.isSaas,
  ApplicationTableColumns.isVisible,
  ApplicationTableColumns.isForConsumers,
  ApplicationTableColumns.productDomain,
  ApplicationTableColumns.createdAt,
  ApplicationTableColumns.updatedAt,
];
